import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, NavLink } from "reactstrap";

const ControlledDropdown = ({ items, onItemSelect, caret = true, dropdownOpen, setDropdownOpen, children}) => {
    const toggle = () => setDropdownOpen(prevState => !prevState);
    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} nav>
            <DropdownToggle caret={caret} color="default" nav onClick={(e) => e.preventDefault()}>
                {children}
                <b className="caret d-none d-lg-block d-xl-block" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-navbar" end tag="ul">
                {items.map((item, index) => (
                    <React.Fragment key={index}>
                        {item.isDivider && <DropdownItem divider tag="li" />}
                        <NavLink tag="li">
                            <DropdownItem onClick={() => onItemSelect(item)} className="nav-item">{item.label}</DropdownItem>
                        </NavLink>
                    </React.Fragment>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default ControlledDropdown